import { CommonService } from '@/services/common.service'
import { SalesManagerService } from '@/services/sales-manager.service'

export default {
  data() {
    return {
      systemConfig: {
        mccDetail: [],
        cashier: [],
        paymentMethod: [],
        posBank: [],
        hasVietQr: [],
        vietQrBank: [],
        hasInstallment: [],
        installmentBank: [],
        businessFields: [],
        services: [],
        baseMccDetail: [],
        storeLocation: [],
      },
    }
  },
  mounted() {},
  computed: {},
  methods: {
    getConfigSystem() {
      return CommonService.getConfigSystem()
        .then(data => {
          if (data.success) {
            const config = data.data
            this.systemConfig = {
              cashier: this.map(config.cashier),
              paymentMethod: this.map(config.paymentMethod),
              posBank: this.map(config.posBank),
              hasVietQr: this.map(config.hasVietQr),
              vietQrBank: this.map(config.vietQrBank),
              hasInstallment: this.map(config.hasInstallment),
              installmentBank: this.map(config.installmentBank),
              businessFields: this.map(config.businessFields),
              services: this.map(config.services),
              storeLocation: this.map(config.storeLocation),
              baseMccDetail: config.mccDetail,
              averageOrder: this.map(config.averageOrder),
              averageAge: this.map(config.averageAge),
              licenseBusiness: this.map(config.licenseBusiness),
              knowMPOS: this.map(config.knowMPOS),
              ownPOS: this.map(config.ownPOS),
              softwareUseState: this.map(config.softwareUseState),
              storeManagementSoftware: this.map(config.storeManagementSoftware),
              bannerState: this.map(config.bannerState),
              mcSource: this.map(config.mcSource),
              leadDataSource: this.map(config.leadDataSource),
            }
            this.getListService()
          }
        })
        .catch(error => console.log(error))
    },
    map(items, id = 'code', text = 'name') {
      return items.map(e => ({ id: e[id], text: e[text] }))
    },
    getMccDetail(code) {
      const mccDetail = this.systemConfig.baseMccDetail.find(s => s.code === code)
      return mccDetail?.detail.map(e => ({ id: e, text: e }))
    },
    async getListService() {
      try {
        const response = await SalesManagerService.getGroupService({})
        if (response.code === 1000) {
          console.log(response)
          const dataGroupService = response.data.groupService
          const data = dataGroupService.filter(e => e.service === 'SELL')
          if (data[0]?.detail.length > 0) {
            data[0]?.detail.map(e => {
              const body = {
                id: e.code,
                text: this.serviceTypes(e.name),
              }
              this.systemConfig.services.push(body)
            })
          }
        }
      } catch (error) {
        console.log(error, '=========>')
      }
    },
    serviceTypes(itemm) {
      const listServiceTypes = this.Config.listServiceTypes
      return listServiceTypes[itemm] ? listServiceTypes[itemm] : itemm
    },
  },
}
